import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from '@/router';
import { SeasonProvider } from '@/lib/season/SeasonContext';
import { queryClient } from '@/lib/queryClient';
import { Toaster } from '@/components/ui/toaster';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SeasonProvider>
        <RouterProvider router={router} />
        {/* Один тостер на всё приложение — вне роутера, чтобы уведомление
            переживало навигацию и работало на экранах без AppShell (логин,
            восстановление пароля). */}
        <Toaster />
      </SeasonProvider>
    </QueryClientProvider>
  );
}
